import script from "./CouponReservationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponReservationForm.vue?vue&type=script&setup=true&lang=js"

import "./CouponReservationForm.vue?vue&type=style&index=0&id=481f0da4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481f0da4"]])

export default __exports__